import moedasMetadata from './data/metadata.json';
import type { MoedasDataVersion } from './types.js';

export const MOEDAS_DATA_VERSION: MoedasDataVersion = moedasMetadata as MoedasDataVersion;
